/**
 * Extract the first-level string
 * @param {String} input
 * @returns {Array<String>}
 */
function extractFirstLevelSpaces(input) {
  let result = [];
  let buffer = "";
  let bracketDepth = 0;
  let parenDepth = 0;

  if (input.includes("/*")) {
    input = input.replace(/\/\*(.*?)\*\//g, "").trim();
  }

  for (const char of input) {
    /** Track bracket and parenthesis depth */
    if (char === "(") {
      parenDepth++;
    } else if (char === ")") {
      parenDepth--;
    } else if (char === "[") {
      bracketDepth++;
    } else if (char === "]") {
      bracketDepth--;
    }

    /** Only handle spaces outside of brackets and parentheses */
    if (char === " " && bracketDepth === 0 && parenDepth === 0) {
      if (buffer.trim()) {
        result.push(buffer.trim());
        buffer = "";
      }
    } else {
      buffer += char;
    }
  }

  /** Push the final buffer if not empty */
  if (buffer.trim()) {
    result.push(buffer.trim());
  }

  return result;
}

export default extractFirstLevelSpaces;
